import store from "../../../store/store"
import { getAlbumsPhotos, getSharedSingleAlbumInfo } from "../../single_album_view/meta/slices"
import { deleteIndividualAlbum, removeSelectedAlbumData, deleteFrinedsIndividualAlbum, unSelectedAlbumData } from "../meta/slices"
import { hideDropdownMenu, toggleElementById } from "../../../utils/common_utils"

/* global photoOrg */
const getDispatch = () => store.dispatch;

const handleAlbumSelection = (selectIcon, albumId) => {
    try{
        photoOrg.cLog('single album success response');
        if(selectIcon){
            photoOrg.Util.trackLinksAndButtons('albumSelection','albumsPage',{trackerId:"ALBUM_SELECTED",'trackerData':["aid:"+ albumId]});
            if(photoOrg.photoLib.config.loadAsPhotoPicker){
                photoOrg.selectionManager.updatePickerSelelctedAlbumIdsToStorage(albumId);//Albums which are selected in picker are added to a diff key in storage.
            }else {
                photoOrg.selectionManager.setSelectedAlbumIdInStorage(albumId);
            }
        }else{
            photoOrg.Util.trackLinksAndButtons('albumUnSelection','albumsPage',{trackerId:"ALBUM_DESELECTED",'trackerData':["aid:"+ albumId]});
            photoOrg.selectionManager.deleteAlbumInfoInLocalStorage(albumId);
        }  
    }catch(e){
        photoOrg.clientLogger.error({description: "LIBRARY:albums_view:handleAlbumSelection:Exception", errorCode: "LIBRARY:MYPHOTOS", err_desc: e, err_stack: e.stack});
    }    
}

export default {
    redirectToPrints: function(albumId,isTouchDevice) {
        hideDropdownMenu();
        var count = photoOrg.selectionManager.getAssetsCount();
        var albumModel = photoOrg.photoLib.albumModelList[albumId];
        if (photoOrg.Util.isSelectionOverPrintLimit(count || albumModel.imagesCount)) {
            (photoOrg.orderPrintsLimitOverlay || (photoOrg.orderPrintsLimitOverlay = new photoOrg.OrderPrintsLimitOverlayView({}))).show();
            return;
        }
        photoOrg.Util.trackLinksAndButtons('Albums_OrderPrintsIcon', 'albumsPage',{'trackerId': "PRINT_ENTIRE_ALBUM", 'trackerData':["aid:"+albumId]});
        //For mobile show the prints overlay.
        if (!photoOrg.storage.getValueFromStorage(photoOrg.constants.storagekeys.DONT_SHOW_PRINTS_CONFIRMATION,{addAccountId: true}) && isTouchDevice && photoOrg.printsConfirmation) {             
            photoOrg.printsConfirmation.init({orderPrints: this.orderPrints.bind(this,albumId)})
        } else {//for desktop
            this.orderPrints(albumId);
        }
    },
    orderPrints: function(albumId) {
        try {
            photoOrg.cLog("Order Prints....");
            hideDropdownMenu();
            var albumModel = photoOrg.photoLib.albumModelList[albumId];
            var url = photoOrg.config.prints_builder_url + "?" + photoOrg.config.prints_sku_4x6 + "&albumId=" + albumId
            var historyState = photoOrg.history.historyState;
            
            if (historyState.pg && historyState.pg.indexOf(photoOrg.constants.SHARED_WITH_ME_ALBUM_VIEW) !== -1 && photoOrg.history.historyState.st == photoOrg.constants.HOST_VIEW) {//host view
                url += "&accountId=" + albumModel.ownerAccountId + "&albumType=friends" + "&dc=" + albumModel.dataCenter
            } else if (historyState.pg && historyState.pg.indexOf(photoOrg.constants.MY_SHARED_ALBUM_VIEW) !== -1) {//myShared
                url += "&albumType=myshared" + "&dc=" + albumModel.dataCenter
            }
            //When clicked on order print, we carry the album id, therefore it should be updated in the local storage, removing all other albums.
            photoOrg.storage.setValueInStorage(photoOrg.constants.storagekeys.SELECTED_ALBUMS,[albumId],{addAccountId: true});
            
            photoOrg.cLog("Redirect Prints URL....",url);
            window.location.href = url
        } catch (e) {
            photoOrg.clientLogger.error({description: "LIBRARY:albums_view:orderPrints:Exception", errorCode: "LIBRARY:MYALBUMS", err_desc: e, err_stack: e.stack});
        }
    },
    openSlideshow: function(event) {
        try {
            /**
             *  combintation of 
             *  "touchend" listener can call evt.preventDefault() and your
             *  "mouseup" listeners won't fire because they come later in the chain.
             * 
             * touchstart and mouseDown combination is not working meaning both listeners are working in touch devices
             */
            event.preventDefault();
            event.stopPropagation();
            photoOrg.cLog("Album Slideshow...");
            
            let albumId = document.getElementsByClassName("menu_active")[0].getAttribute("id");
            if(albumId.indexOf("album_") !== -1){
                albumId = albumId.split("_")[1];
            }
            console.log("slidshow albumId",albumId);
            new photoOrg.albumSlideShowController({albumId: albumId, albumModel: photoOrg.photoLib.albumModelList[albumId]});
            photoOrg.Util.trackLinksAndButtons('Slide Show', photoOrg.constants.pageNames[photoOrg.history.historyState.pg]);
            setTimeout(()=>{
                hideDropdownMenu();
            },250)
        } catch (e) {
            photoOrg.clientLogger.error({description: "LIBRARY:albums_view:slideshow:Exception", errorCode: "LIBRARY:MYALBUMS", err_desc: e, err_stack: e.stack});
        }
    },
    shareAlbum : function(event){
        try{
            event.stopPropagation();
            console.log("global_actions -  shareAlbum...");

            const restrictionApplied = photoOrg.Util.restrictDownloadShareOptions();
            if (restrictionApplied) {
                // Stoping further execution if restriction was applied
                return;
            }
            hideDropdownMenu();
            let albumId = document.getElementsByClassName("menu_active")[0].getAttribute("id");
            if(albumId.indexOf("album_") !== -1){
                albumId = albumId.split("_")[1];
            }
            photoOrg.Util.trackLinksAndButtons('Albums_ShareIcon','albumsPage');
            photoOrg.Util.initializeShareWidget('GLOBALACTIONS', 'SINGLE_ALBUM_SHARE',{'albumModel' : photoOrg.photoLib.albumModelList[albumId]})
        }catch(e){
            photoOrg.clientLogger.error({description: "LIBRARY:albums_view:shareAlbum:Exception", errorCode: "LIBRARY:MYPHOTOS", err_desc: e, err_stack: e.stack});
        }
    },
    selectDeselect : function(albumId, selectedAlbumDataRes, setAlbumSelected,deSelectAlbum){
        try{
            if(!deSelectAlbum){
                photoOrg.Util.trackLinksAndButtons('albumSelection','albumsPage',{trackerId:"ALBUM_SELECTED",'trackerData':["aid:"+albumId]});
            }else{
                photoOrg.Util.trackLinksAndButtons('albumUnSelection','albumsPage',{trackerId:"ALBUM_DESELECTED",'trackerData':["aid:"+albumId]});
            }
            if( deSelectAlbum && selectedAlbumDataRes && setAlbumSelected){
                this.addImagesToTray(selectedAlbumDataRes.entities, albumId, false);
                setAlbumSelected(false)
                getDispatch()(removeSelectedAlbumData(albumId))
                toggleElementById("loadingBar", "none");
                if(photoOrg.config.restrict_album_selection && photoOrg.selectionManager.getAssetsCount() <= photoOrg.constants.MAX_PRINT_SELECTION_LIMIT){
                    $(".link-to-prints").removeClass("showWarningSymbol");
                }
                return;
            }
            const params = {
                'sortCriteria': 'dateTaken',
                'assetType':'PICTURE',
                'sortOrder': 'ascending',
                'albumId': albumId,
                deSelectAlbum 
            };
            if(photoOrg.config.video){
                params.assetType = 'ALL';                    
            }
            const historyState = photoOrg.history.historyState;
            const albumModel = photoOrg.photoLib.albumModelList[albumId]; 
            if(historyState.pg && historyState.pg.indexOf(photoOrg.constants.SHARED_WITH_ME_ALBUM_VIEW) !== -1) {                    //friends albums view
                params.accessType = photoOrg.photoLib.accessType.sharedWithMe;
                params.dc = albumModel.dataCenter;//Adding datacenter for Friends assets as well.
                params.ownerId = albumModel.ownerAccountId
                params.datacenter = albumModel.dataCenter;
                getDispatch()(getSharedSingleAlbumInfo(params));
            }else if(historyState.pg && historyState.pg.indexOf(photoOrg.constants.MY_SHARED_ALBUM_VIEW) !== -1) {                  //my shared albums view
                
                params.accessType = photoOrg.photoLib.accessType.myShared;
                params.ownerAccountId = albumModel.ownerAccountId
                params.dataCenter = albumModel.dataCenter;
                getDispatch()(getAlbumsPhotos(params));

            }else { //get owned info call irrespective of whether it is shared or not shared.
                getDispatch()(getAlbumsPhotos(params));
            }
        }catch(e){
            photoOrg.clientLogger.error({description: "LIBRARY:albums_view:selectDeselect:Exception", errorCode: "LIBRARY:MYPHOTOS", err_desc: e, err_stack: e.stack});
        }
    },
     deleteAlbum : function(albumId, monthNYearKey){
        try{
            const sortOrder = photoOrg.history.historyState.so;
            const sortCriteria = photoOrg.history.historyState.sc;
            const albumModel = photoOrg.photoLib.albumModelList[albumId];
            //photoOrg.photoLib.doCollectionAssetRequestAndShowConfirmation(albumId, albumModel);
            if (photoOrg.history.historyState.pg && (photoOrg.history.historyState.pg.indexOf(photoOrg.constants.SHARED_WITH_ME_ALBUM_VIEW) !== -1
            || photoOrg.history.historyState.pg.indexOf(photoOrg.constants.SHARED_WITH_ME_SINGLE_ALBUM_VIEW) !== -1
            || (photoOrg.history.historyState.pg.indexOf(photoOrg.constants.AG_SHARED) !== -1 && !albumModel.isShared))){
                const params = {
                    albumId : albumId
                };
                getDispatch()(deleteFrinedsIndividualAlbum(params))
            }else{
                getDispatch()(deleteIndividualAlbum({
                    albumId:albumId,
                    projection: "firstAssetId,userTags",
                    sortCriteria: sortCriteria,
                    sortOrder: sortOrder,
                    monthNYearKey: monthNYearKey,
                    isMySharedDeleteAlbum: (photoOrg.history.historyState.pg.indexOf(photoOrg.constants.MY_SHARED_ALBUM_VIEW) !== -1)
                }));
                $("#deleteConfirmation").foundation('reveal','close');
            }
        }catch (e) {
            photoOrg.clientLogger.error({description: "LIBRARY:albums_view:deleteAlbum:Exception", errorCode: "LIBRARY:MYALBUMS", err_desc: e, err_stack: e.stack});
        }
    },
    loadSingleAlbumView: function(event, albumId){
        try{
            const albumModel = photoOrg.photoLib.albumModelList[albumId];
            var isFavorite = photoOrg.assetUtils.getValue(albumModel.systemTags, 'isFavorite') === "true";
            if(photoOrg.config.is_snapfish_branding){
                const subHeaderEle = document.querySelector('.sub-header-wrapper');
                subHeaderEle.classList.remove('memory-on');
            }
            //if album is favorite album, redirecting the user to cluster fav view.
            //should not go to fav view, if user click on selectAll button.
            if(isFavorite && !event.target.classList.contains("selectAllAblum")){
               return photoOrg.libraryController.navigateToFavClusterView();
            }
            photoOrg.selectedAlbumId = albumId;
            photoOrg.photoLib.isShared = albumModel.isShared;
            photoOrg.photoLib.customSortEnabled = albumModel.customSortEnabled; 
            photoOrg.history.historyState.pg === photoOrg.constants.ALBUMS_VIEW && photoOrg.albumView.getAlbumMonthAndYear(albumId);
            hideDropdownMenu();
            photoOrg.photoLib.loadSingleAlbumView(albumModel);
        }catch (e) {
            photoOrg.clientLogger.error({description: "LIBRARY:albums_view:loadSingleAlbumView:Exception", errorCode: "LIBRARY:MYALBUMS", err_desc: e, err_stack: e.stack});
        }
    },
    checkAndRedirectMYFriendsToNoPhotosPage: function(accountHasOwnedAlbums){
        //if they are no owned albums as well and if not inline ingestion view then redirect to empty photos page
        //For inline ingestion view, we should show empty msg in the respective source tab
        if(accountHasOwnedAlbums === "false" && !photoOrg.aggSdkUtils.isInlineIngestionViewEnabled()) {
            photoOrg.photoLib.showAndHideUploadTextDiv('show');
            photoOrg.history.resetHistoryState();//Reset the history state to default albums flow. As it is causing issue after uploading.
        }
        else{//else show the empty friends album page
            photoOrg.photoLib.showAndHideSharedEmptyMsgDiv("show");
            //$('.shared-filtering-menu .selected-option').text(photoOrg.translations.photos['sub_header']['shared_with_me']);//While navigating to empty friends album page,shared filter should be Friends Album.
        }
        //$('.photo-Org #loadingBar').hide();
        //$(".photo-Org #bottomLoadingBar").hide();
        document.getElementById("bottomLoadingBar").style.display = "none";
    },

    addImagesToTray: function(selectedAlbumDataRes, albumId, albumSelected){
        try{
            photoOrg.cLog("In addImagesToTray method")
            //var pict_ids = [];
            const not_in_photoWell = [];
            const collection = new photoOrg.pictCollection();
            for(var i=0; i< selectedAlbumDataRes.length; i++){
                if(selectedAlbumDataRes[i].id === undefined){
                    selectedAlbumDataRes[i].id = selectedAlbumDataRes[i].assetId;
                }
                //pict_ids.push(data[i].id);
                var pict_model = new photoOrg.pict(selectedAlbumDataRes[i]);
                collection.add(pict_model);
                if(!photoOrg.selectionManager.isAssetModelInPhotoWell(pict_model)){
                    not_in_photoWell.push(selectedAlbumDataRes[i].id);
                }
            }
            const doToggle = true;

            const last_pict_index = not_in_photoWell.length - 1;
            not_in_photoWell.every(function(pid, index){
                const currentModel = collection.get(pid);
                if(albumSelected) {

                    if(photoOrg.pickerSelValidator && photoOrg.pickerSelValidator.isMaxCapacityProduct){
                        const isLastImage = (index === last_pict_index) ? true: false;
                        const status = photoOrg.pickerSelValidator.validateAlbumSelection(currentModel, isLastImage);
                        //{'maxCapacityReached': false, 'imageReachedMaxSize': false}
                        if(status.maxCapacityReached){
                            doToggle = false;
                            //There is chance of next images may be less size, so we have to check for next images and we should not break.
                            //we have to break the loop if maxPhotosCountReached as true.
                            return (!status.maxPhotosCountReached);

                        }else if(status.imageReachedMaxSize){
                            doToggle = false;
                            return true;
                        }
                    }
                    
                    photoOrg.selectionManager.addAssetByModel(currentModel);//Adding selected picture information to the selectassets collection.
                    photoOrg.projectTrayView && photoOrg.projectTrayView.addAssetToTray({'model' : currentModel})
                    photoOrg.selectionManager.storeAlbumIdOfSelectedImages(currentModel.id, albumId)
                }else {
                    photoOrg.photoLib.getElementById( pid + "po_sav").removeClass("selected");
                    photoOrg.selectionManager.removeAsset(currentModel);//Removing un selected picture information from the selectedAssets collection,
                    photoOrg.projectTrayView && photoOrg.projectTrayView.removeAssetFromTray(pid)
                    photoOrg.selectionManager.deleteAlbumIdFromSelectedImageAlbums(currentModel.id)
                    if(!photoOrg.photoLib.config.loadAsPhotoPicker)
                        photoOrg.selectionManager.updateSelectedImagesAlbumIdIntoStorage();
                }
                photoOrg.globalActions.trigger(eventBus.CUSTOM_EVENT_UPDATE_ASSET_SELECTION_COUNT, currentModel);//trigger or publishing the CUSTOM_EVENT_UPDATE_ASSET_SELECTION_COUNT
                return true;
          })
          if(albumSelected){//albumSelected will be true
                if(!photoOrg.photoLib.config.loadAsPhotoPicker){
                    photoOrg.selectionManager.updateSelectedImagesAlbumIdIntoStorage();
                }
                if(doToggle){//doToggle will be true if all photos are selected
                    handleAlbumSelection(true, albumId);
                    if(photoOrg.photoLib.config.loadAsPhotoPicker){
                        //show the selected_entire_album and hide
                        $('.' + albumId+"_album-select-confirm-label").show().fadeOut(8000);
                    }
                }
            }else{
                handleAlbumSelection(false, albumId);
                getDispatch()(unSelectedAlbumData())
            }                     

        if(photoOrg.photoLib.config.loadAsPhotoPicker) {
            photoOrg.photoLib.handleImageSelCountDomUpdates();
            photoOrg.photoLib.toggleDoneAndAddPhotosButton();
          }
        }catch(e){
            photoOrg.clientLogger.error({description: "LIBRARY:albums_view:addImagesToTray:Exception", errorCode: "LIBRARY:MYPHOTOS", err_desc: e, err_stack: e.stack});
        }
    },
   
}
